import { render, staticRenderFns } from "./project-request-to-bid-button.vue?vue&type=template&id=dbbd4eb8&"
import script from "./project-request-to-bid-button.vue?vue&type=script&lang=js&"
export * from "./project-request-to-bid-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports